import { faKey } from '@fortawesome/pro-solid-svg-icons'
import AppHandoff from './AppHandoff'
import { mobileAppUrl } from './appHandoffModel'

export type Props = {
  token: string
  email: string
}

const INVALID_LINK_MESSAGE = 'This password reset link is not valid. Please request a new one from the app.'

const ResetPasswordInApp = ({ token, email }: Props) => <AppHandoff
  token={token}
  appUrl={token && email ? mobileAppUrl('forgot-password', { token, email }) : null}
  invalidLinkMessage={INVALID_LINK_MESSAGE}
  prompt="Opening the SynkedUP app so you can choose a new password. If it does not open on its own, tap the button below."
  alreadyOpenedPrompt="This link has already opened the SynkedUP app on this device. You can close this tab. If you still need to choose a new password, tap the button below."
  buttonLabel="Choose a New Password"
  icon={faKey}
/>

export default ResetPasswordInApp
